@if (basdata && searchFilter) {
  <rask-arbetsorder-search-filter [title]="texts.filters.tid" (toggleVisibility)="toggleShow()" [visible]="isVisible"
    [hasValues]="isDirty()" aid="filterTid">
    <div class="row">
      <div class="col-6">
        <div class="w-100">
          <rask-selector label="skördning skotning" [values]="skordningSkotningValues" [canDelete]="false"
            [(ngModel)]="skordningSkotning">
          </rask-selector>
        </div>
        <rask-datepicker-interval
          [appendToBody]="false"
          [labelStartDate]="texts.produktionsdatumFrom"
          [labelEndDate]="texts.produktionsdatumTom"
          startDate="{{periodFromDate}}"
          (startDate)="setPeriodFromDate($event)"
          endDate="{{periodTomDate}}"
          (endDate)="setPeriodTomDate($event)"
          [onlyMonths]="false"
          aid="filterTidProduktionsdatum">
        </rask-datepicker-interval>
        <rask-datepicker label="periodsatt period" [onlyMonths]="true"
          [appendToBody]="false"
        [(ngModel)]="periodsattPeriod"></rask-datepicker>
        <rask-checkbox aid="filterTidEjTidsatta" [text]="texts.ejTidsatta"
          [(ngModel)]="searchFilterEjTidsatta">
        </rask-checkbox>
      </div>
      <div class="col-6">
        <rask-datepicker-interval
          [appendToBody]="false"
          [labelStartDate]="texts.arbetsorderSkapadFrom"
          [labelEndDate]="texts.arbetsorderSkapadTom"
          startDate="{{arbetsorderCreatedDateFrom}}"
          (startDate)="setArbetsorderCreatedDateFrom($event)"
          endDate="{{arbetsorderCreatedDateTom}}"
          (endDate)="setArbetsorderCreatedDateTom($event)"
          [onlyMonths]="false"
          aid="filterTidArbetsorderSkapad">
        </rask-datepicker-interval>
        <rask-datepicker label="Fältplanerat datum äldre än" infoText="Arbetsordern innehåller åtminstone en åtgärd som har planeringsdatum äldre än eller lika med datum"
          [appendToBody]="false"
          [(ngModel)]="faltplaneratDatum">
        </rask-datepicker>
      </div>
    </div>
    <div class="virkesorder-panel">
      <div class="dummy-component-for-header header-pos">
        <fieldset>
          <label>{{texts.virkesorder}}</label>
        </fieldset>
      </div>
      <div class="row">
        <div class="col-12">
          <rask-datepicker-interval
            [appendToBody]="false"
            [labelStartDate]="texts.virkesorderSkapadFrom"
            [labelEndDate]="texts.virkesorderSkapadTom"
            startDate="{{virkesorderSkapadFrom}}"
            (startDate)="setVirkesorderCreatedDateFrom($event)"
            endDate="{{virkesorderSkapadTom}}"
            (endDate)="setVirkesorderCreatedDateTom($event)"
            [onlyMonths]="false"
            aid="filterTidVirkesorderSkapad">
          </rask-datepicker-interval>
          <rask-datepicker-interval
            [appendToBody]="false"
            [labelStartDate]="texts.virkesorderGiltigFrom"
            [labelEndDate]="texts.virkesorderGiltigTom"
            startDate="{{virkesorderGiltigFrom}}"
            (startDate)="setVirkesorderGiltigDateFrom($event)"
            endDate="{{virkesorderGiltigTom}}"
            (endDate)="setVirkesorderGiltigDateTom($event)"
            [onlyMonths]="false"
            aid="filterTidVirkesorderGiltig">
          </rask-datepicker-interval>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <rask-datepicker-interval
            [appendToBody]="false"
            [labelStartDate]="texts.virkesorderAndradFrom"
            [labelEndDate]="texts.virkesorderAndradTom"
            startDate="{{virkesorderAndradFrom}}"
            (startDate)="setVirkesorderAndradDateFrom($event)"
            endDate="{{virkesorderAndradTom}}"
            (endDate)="setVirkesorderAndradDateTom($event)"
            [onlyMonths]="false"
            aid="filterTidVirkesorderAndrad">
          </rask-datepicker-interval>
        </div>
      </div>
    </div>
  </rask-arbetsorder-search-filter>
}